import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import firebase from "firebase";

//Mui
import { Button } from "@material-ui/core";
import { Grid } from "@material-ui/core";
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';
import TextField from "@material-ui/core/TextField";
import { makeStyles } from "@material-ui/core/styles";
import db, { storage } from "../../firebase/firebase";
import { selectUser } from "../../store/reducers/userSlice";
import { setCharacter, setActiveCharacter } from "../../store/reducers/characterSlice";
import classes from "./Welcome.module.css";

import logo from "../../img/logo_500x500white.png";

const useStyles = makeStyles({

  root: {
    
    "& .MuiOutlinedInput-root": {
      color: "white"
    },

    "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
      borderColor: "white",
    
    },
    "&:hover .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
      borderColor: "#2E3036"
    },
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "#2E3036"
    }
  }
});

function Welcome() {
  const history = useHistory();
  const overrides = useStyles();
  const user = useSelector(selectUser);
  const dispatch = useDispatch();
  const [charName, setCharName] = useState("");
  const handleInputChange = (e) => {
    setCharName(e.target.value);
  };


  const handleAddCharacter = () => {
    let newCharacter = null;
    let storageRef = storage.ref();
    let imagesRef = storageRef.child("/resources/images/avatars/Ms_Who.png");
    let macroRef = storageRef.child("/resources/images/macros/42.png");
    // let newCharName = charName;

    var storageRefRoom = storage.ref();
    var imagesRefRoom = storageRefRoom.child("/resources/images/rooms/T_Emblem_NoBG_21.png");
    const roomName = "Your Training Room";
    
    imagesRefRoom.getDownloadURL().then((url) => {
        db.collection("channels").add({
          channelName: roomName,
          channelOwner: user.uid,
          channelUsers: [user.uid],
          channelImage: url,
        });
      });
      
    newCharacter = {
      characterName: charName,
      critEmote: "Cower in terror felbeasts!",
      critFailEmote: "No...no...It cannot be!?!?!",
      macro1: "#d20",
      macro2:
        "My friends, my friends I have composed a short sonnet for just such an occasion.",
      macro3: "#4d6+2",
    };

    imagesRef.getDownloadURL().then((url) => {
      macroRef.getDownloadURL().then((macroUrl) => {
        newCharacter["macro1Icon"] = macroUrl;
        newCharacter["macro2Icon"] = macroUrl;
        newCharacter["macro3Icon"] = macroUrl;
        newCharacter["characterPortrait"] = url;
        db.collection("users").doc(user.uid).collection("characters").add({
          timestamp: firebase.firestore.FieldValue.serverTimestamp(),
          uid: user.uid,
          character: newCharacter,
        })
        .then(function(docRef) {
          console.log("Document written with ID: ", docRef.id);
          dispatch(setActiveCharacter(docRef.id));
          db.collection("users").doc(user.uid).set({
            avatar: newCharacter.characterName,
            portrait: newCharacter.characterPortrait,
            id:docRef.id,
          });
      });
        
        dispatch(setCharacter(newCharacter));
        history.push("/profile");
        //dispatch(setActiveCharacter(id));
      });
    });
  };

  

  return (
    <div className={classes.welcome}>
      <Grid
        container
        spacing={3}
        direction="column"
        alignItems="center"
        justify="center"
      >
        <Grid item xl={12} xs={12}>
          <div className={classes.wrapper} >
            <img src={logo} alt="welcome!" />
          </div>
        </Grid>

        <div className={classes.gradient__box}>
          <Grid item xs={12}>
            <TextField
              className={overrides.root}
              name="character name"
              onChange={handleInputChange}
              variant="outlined"
              label="Your character's name"
              id="outlined-name"
              color="primary"
              labelclassName={overrides.root}
            />
            <Button
              className={classes.TextField__button}
              onClick={handleAddCharacter}
              variant="contained"
              label="Begin"
              color="primary"
              size="small"
              startIcon={<KeyboardArrowRightIcon />}
            >
              {" "}
        Begin{" "}
            </Button>
          </Grid>
        </div>

      </Grid>
    </div>


  );
}

export default Welcome;
